import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

export default function ProductInfoDialog(props) {
  return (
      <Dialog open={props.open} onClose={props.onProductInfoDialogClosed} scroll="body">
        <DialogContent className="product-info-dialog-content">
          <IconButton className="product-info-close-button" aria-label="close" onClick={props.onProductInfoDialogClosed}>
            <CloseIcon />
          </IconButton>

          <h4>Disability Income Insurance</h4>
          <p>Ameritas DInamic Fundamental®</p>

          <p>
            DInamic Fundamental from Ameritas Life Insurance Corp. allows you to protect your most valuable asset – your income – in the event you become too sick or hurt
            to work. The product is simple, priced to fit within your budget and offers a streamlined underwriting process.
          </p>

          <h4>Why should you consider DInamic Fundamental* for your income protection needs?</h4>
          <ul>
            <li>
              Just over one in four of today’s 20-year olds will become disabled before they retire. <sup>1</sup>
            </li>
            <li>
              It is estimated that there are over 36 million disabled Americans–12% of the total population. More than 50% of those disabled Americans are in their
              working years, ages 18-64. <sup>2</sup>
            </li>
            <li>
              Medical conditions contributed to 62%<sup>3</sup> of all personal bankruptcies filed in the U.S. in 2007 - an estimate of over 500,000.<sup>4</sup> A 49.6%
              increase over results from a similar study in 2001.
            </li>
            <li>
              65% of working Americans say they could not cover normal living expenses even for a year if their employment income was lost; 38% could not pay their bills
              for more than three months.<sup>5</sup>
            </li>
          </ul>

          <h4>How does DInamic Fundamental help protect your ability to earn an income?</h4>
          <h4>It’s Simple</h4>
          <ul>
            <li>You can purchase a benefit amount up to one times your annual earnings, not to exceed $100,000 </li>
            <li>
              Pays a single lump sum benefit for total disability that is expected to last at least one year, provided you survive the disability for at least 30 days.
            </li>
            <li>No additional benefit riders</li>
            <li>Coverage period is to age 65</li>
            <li>Policy terminates once claim payment is made</li>
          </ul>

          <h4>It’s Affordable</h4>
          <ul>
            <li>Pricing compares well with other common bill payments (cable, internet, etc.) </li>
            <li>You can purchase a benefit amount up to one times your annual earnings, not to exceed $100,000</li>
            <li>Level premium structure, meaning you pay the same amount every month</li>
            <li>Premium is based on percentage of manual duties performed in your occupation</li>
          </ul>

          <h4>It’s Attainable</h4>
          <ul>
            <li>Simplified underwriting process </li>
            <ul>
              <li>No blood or urine tests or paramedical exams</li>
              <li>No Attending Physicians Statements (APS) or Personal History Interviews (PHI) required</li>
              <li>No income documentation</li>
              <li>Short and simple application</li>
            </ul>
            <li>No extra premium charge for substandard risks</li>
            <li>Limited exclusions, for certain medical conditions, may be used when needed</li>
          </ul>

          <p style={{ marginBottom: '0px' }}>
            With DInamic Fundamental, we’ve made it easier and more affordable than ever to own individual Disability Income (DI) protection. For more information about
            Disability Income insurance or any other products for personal, family or business needs, contact your insurance representative.
          </p>
          <small style={{ fontSize: '8px' }}>* May not be available in all states. State variations may apply. Please refer to actual policy for details.</small>

          <div style={{ marginTop: '25px' }}>
            <h6>Sources:</h6>
            <p>1. U.S. Social Security Administration, Fact Sheet February 7, 2013 </p>
            <p>2. U.S. Census Bureau, American Community Survey, 2011 </p>
            <p>
              3. The American Journal of Medicine, June 4, 2009 Medical Bankruptcy in the United States, 2007: Results of a National Study; David U. Himmelstein, MD,
              Deborah Thorne, PhD, Elizabeth Warren, JD, Steffie Woolhandler, MD, MPH
            </p>
            <p>4. U.S. Courts, Bankruptcy Statistics, 12-Month Period Ending December 2007</p>
            <p>5. Council for Disability Awareness, Disability Divide</p>
          </div>

          <p>
            In approved states, DInamic Fundamental® (form 4504LS) is issued by Ameritas Life Insurance Corp. In New York, DInamic Fundamental® (form 5504-LS) is issued
            by Ameritas Life Insurance Corp. of New York. Policy and riders may vary and may not be available in all states.
          </p>
          <p>
            This information is provided by Ameritas®, which is a marketing name for subsidiaries of Ameritas Mutual Holding Company, including, but not limited to,
            Ameritas Life Insurance Corp., located at 5900 O Street, Lincoln, NE 68510, Ameritas Life Insurance Corp. of New York, located at 1350 Broadway, Suite 2201,
            New York, New York 10018 and Ameritas Investment Corp, member FINRA/SIPC. Ameritas Life Insurance Corp. of New York is licensed in New York. Each company is
            solely responsible for its own financial condition and contractual obligations. For more information about Ameritas®, visit ameritas.com.
          </p>
          <p>
            Ameritas® and the bison design are registered service marks of Ameritas Life Insurance Corp. Fulfilling life® and DInamic Fundamental® are registered service
            marks of affiliate Ameritas Holding Company.
          </p>
          <p> © 2014 Ameritas Mutual Holding Company</p>
        </DialogContent>
      </Dialog>
  );
}

ProductInfoDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onProductInfoDialogClosed: PropTypes.func.isRequired,
};




// WEBPACK FOOTER //
// ./src/components/Quoters/Ameritas/Helpers/ProductInfoDialog.js